import {NgModule} from '@angular/core';
import {PcConfigPage} from "./page/overview/pc-config/pc-config.page";
import {PcCallDialComponent} from "./component/protected-components/pc-call-dial/pc-call-dial.component";
import {PcCallActiveComponent} from "./component/protected-components/pc-call-active/pc-call-active.component";
import {
    PcHeaderCallActiveComponent
} from "./component/protected-components/pc-header-call-active/pc-header-call-active.component";
import {
    PcCallWfProcessStepActivitySideComponent
} from "./component/protected-components/wf/pc-call-wf-process-step-activity-side/pc-call-wf-process-step-activity-side.component";
import {PcCallComponent} from "./component/protected-components/pc-call/pc-call.component";
import {
    PcCallProtocolComponent
} from "./component/protected-components/pc-call-protocol/pc-call-protocol.component";
import {PcCallPage} from "./page/object/pc-call-page/pc-call.page";
import {PcMyCallsPage} from "./page/overview/pc-me/pc-my-calls/pc-my-calls.page";
import {PcQmCallControlPage} from "./page/overview/pc-qm/pc-qm-call-control/pc-qm-call-control.page";
import {PcObjectCallsComponent} from "./component/protected-components/pc-object-calls/pc-object-calls.component";
import {PcMyTeamCallsPage} from "./page/overview/pc-team/pc-my-team-calls/pc-my-team-calls.page";
import {PcIncomingCallPage} from "./page/overview/pc-me/pc-incoming-call/pc-incoming-call.page";
import {PcTeamDashboardPage} from "./page/overview/pc-team/pc-team-dashboard/pc-team-dashboard.page";
import {
    PcCallIncomingAtObjectComponent
} from "./component/protected-components/pc-call-incoming-at-object/pc-call-incoming-at-object.component";
import {PcQmCallsPage} from "./page/overview/pc-qm/pc-qm-calls/pc-qm-calls.page";
import {PcQmDashboardPage} from "./page/overview/pc-qm/pc-qm-dashboard/pc-qm-dashboard.page";
import {PcOverviewPage} from "./page/pc-overview-page/pc-overview.page";
import {PcStatisticsComponent} from "./page/pc-overview-page/components/statisticsComponent/pc-statistics.component";
import {PcKpiComponent} from "./page/pc-overview-page/components/kpiComponent/pc-kpi.component";
import {PC_ENTITY_PROVIDER} from "./pc.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {PC_TEST_PROVIDERS} from "./test/pc-test-definition";
import {PC_WF_ACTIVITY_PROVIDER} from "./pc-wf-activity.provider";
import {
    PcCallDialConsultantComponent
} from "./component/protected-components/consultant-component/pc-call-dial/pc-call-dial-consultant.component";


@NgModule({
  declarations: [
    PcConfigPage,
    PcCallDialComponent,
    PcCallIncomingAtObjectComponent,
    PcCallActiveComponent,
    PcHeaderCallActiveComponent,
    PcCallWfProcessStepActivitySideComponent,
    PcCallComponent,
    PcCallProtocolComponent,
    PcCallPage,
    PcMyCallsPage,
    PcQmCallControlPage,
    PcObjectCallsComponent,
    PcMyTeamCallsPage,
    PcIncomingCallPage,
    PcTeamDashboardPage,
    PcQmCallsPage,
    PcQmDashboardPage,
    PcOverviewPage,
    PcStatisticsComponent,
    PcKpiComponent,
      PcCallDialConsultantComponent
  ],
  exports:[
    PcConfigPage,
    PcCallDialComponent,
    PcCallIncomingAtObjectComponent,
    PcCallActiveComponent,
    PcHeaderCallActiveComponent,
    PcCallWfProcessStepActivitySideComponent,
    PcCallComponent,
    PcCallProtocolComponent,
    PcCallPage,
    PcMyCallsPage,
    PcQmCallControlPage,
    PcObjectCallsComponent,
    PcMyTeamCallsPage,
    PcIncomingCallPage,
    PcTeamDashboardPage,
    PcQmCallsPage,
    PcQmDashboardPage,
    PcCallDialConsultantComponent
  ],
    imports: [
        CoreModule,

    ],
  providers: [PC_ENTITY_PROVIDER, PC_TEST_PROVIDERS, ...PC_WF_ACTIVITY_PROVIDER]
})
export class PcModule implements DynamicModule {

  alias = 'pc';

  constructor(private moduleRegistry: ModuleRegistryService) {
    this.moduleRegistry.registerModule(this);
  }

  getKpiComponent() {
    return PcKpiComponent;
  }

  getStatisticsComponent() {
    return PcStatisticsComponent;
  }

}

